export default __webpack_public_path__ + "static/media/icon_calendar.1f8ff561.svg";